import React, { useEffect, useState } from 'react';
import { logoImg } from '../../../assets/images';
import { useDispatch, useSelector } from 'react-redux';

import Drawer from '@mui/material/Drawer';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { appExtraFunctions } from '../../../store/actions/AppActions';
import { myAccountDetailsAction, userLogout } from '../../../store/actions/AuthActions';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getPageContent, productExtraAction } from '../../../store/actions/ProductActions';
import _ from 'lodash';
import { saveUserCartProducts } from '../../../store/actions/CartActions';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { productCategoryOptions } from '../../../utils/appConstants';
import LogoutIcon from '@mui/icons-material/Logout';
import { Switch } from '@mui/material';

const Header = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const customerLinks = [
    { title: 'Home', link: '/' },
    { title: 'About', link: '/about' },
    {
      title: 'Shop',
      link: '/shop',
      subOptions: productCategoryOptions,
      clickEvent: handleShopClick,
    },
    { title: 'Blogs', link: '/blog' },
    { title: 'Contact', link: '/contact' },
  ];

  const adminLinks = [
    { title: 'Orders', link: '/admin/orders' },
    { title: 'Products', link: '/super_admin/products' },
    { title: 'Pincodes', link: '/admin/pincodes' },
    { title: 'Blogs', link: '/admin/blogs' },
  ];

  const user = useSelector(state => state?.auth?.user);
  const token = useSelector(state => state?.auth?.token);
  const adminView = useSelector(state => state?.app?.adminView);
  const cartProducts = useSelector(state => state?.cart?.products) ?? [];
  const userShopFilters = useSelector(state => state?.products?.userShopFilters);
  const allProducts = useSelector(state => state?.products?.allProducts);

  const [showSidebar, setShowSidebar] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [links, setLinks] = useState([...customerLinks]);
  const [searchModal, setSearchModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState([]);

  const handleScroll = () => {
    const currentScroll = window.scrollY;
    setIsSticky(currentScroll > 200);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (allProducts) {
      const options = allProducts.map(a => ({ label: a?.title, value: a?._id }));
      setSearchOptions(options);
    } else if (!allProducts?.[0]) {
      dispatch(getPageContent('getAllProducts'));
    }
  }, [allProducts]);

  useEffect(() => {
    dispatch(appExtraFunctions('btnLoaderOne', false));

    if (cartProducts && cartProducts.length > 0) {
      const addingProducts = _.uniqBy(cartProducts, '_id');

      if (dispatch && token) {
        dispatch(saveUserCartProducts(token, addingProducts));
      }
    }

    if (token) {
      dispatch(myAccountDetailsAction(token));
      dispatch(getPageContent('getUserCartProducts', token));
    }
  }, [token]);

  function handleShopClick(option) {
    const prevShopFilters = userShopFilters ?? {};
    dispatch(productExtraAction('userShopFilters', { ...prevShopFilters, category: option }));
    navigate('/shop');
  }

  function handleViewAll() {
    const prevShopFilters = userShopFilters ?? {};
    dispatch(
      productExtraAction('userShopFilters', { ...prevShopFilters, search: '', category: '' })
    );
  }

  const toggleDrawer = newOpen => () => {
    setShowSidebar(newOpen);
  };

  const handleAddress = () => {
    if (user && user?._id) {
      // dispatch(userLogout());
      navigate('/profile');
    } else {
      navigate('/login');
    }
  };

  const handleAdminView = () => {
    const view = adminView === 'customer' ? 'admin' : 'customer';
    dispatch(appExtraFunctions('adminView', view));
    setShowSidebar(false);
    if (view === 'admin' && user?.isSuperAdmin) {
      setLinks(adminLinks);
      navigate('/admin/orders');
    } else {
      setLinks(customerLinks);
      navigate('/');
    }
  };

  const renderLinks = () => {
    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    return (
      <>
        {links?.map((link, i) =>
          link?.subOptions ? (
            <li className='header_nav' key={i}>
              <Link
                to={link?.link}
                onClick={() => setShowSidebar(false)}
                className={`menu-item-link ${link?.link === pathname ? 'active' : ''}`}
              >
                <span>{link?.title}</span>
              </Link>
              <ul className='sub-menu d-none d-lg-block'>
                <li onClick={() => setShowSidebar(false)}>
                  <Link to={link?.link} className='sub-item-link' onClick={handleViewAll}>
                    View all
                  </Link>
                </li>

                {link?.subOptions?.map((option, i) => (
                  <li
                    key={option}
                    onClick={() => {
                      setShowSidebar(false);
                      link?.clickEvent && link?.clickEvent(option);
                    }}
                  >
                    <a className='sub-item-link'>
                      <span>{option}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          ) : (
            <li key={i} onClick={() => setShowSidebar(false)}>
              <Link
                to={link?.link}
                className={`menu-item-link ${link?.link === pathname ? 'active' : ''}`}
              >
                <span>{link?.title}</span>
              </Link>
            </li>
          )
        )}

        {/* {user && user?.isAdmin && (
          <>
            <li onClick={() => setShowSidebar(false)}>
              <Link
                to='/admin/orders'
                className={`menu-item-link ${'/admin/orders' === pathname ? 'active' : ''}`}
              >
                <span style={{ textTransform: 'capitalize' }}>Orders</span>
              </Link>
            </li>
          </>
        )} */}

        {user && user?.isSuperAdmin && (
          <li onClick={handleAdminView}>
            {/* {adminView == 'admin' ? 'Admin View' : ''} */}
            {/* <Switch {...label} checked={adminView == 'admin'} /> */}
            <Link className={`menu-item-link `}>
              <span style={{ textTransform: 'capitalize' }}>Actions</span>
            </Link>
          </li>
        )}
      </>
    );
  };

  const handleSearchOpen = () => {
    dispatch(getPageContent('getAllProducts'));
    setSearchModal(true);
  };

  const handleSearchModalClose = () => {
    setSearchModal(false);
  };

  const handleSearchSelect = (e, selected) => {
    const prevShopFilters = userShopFilters ?? {};
    // dispatch(
    //   productExtraAction('userShopFilters', {
    //     ...prevShopFilters,
    //     category: 'All',
    //     search: selected?.value,
    //   })
    // );
    // navigate('/shop');
    handleSearchModalClose();

    navigate(`/product/${selected?.value}`);
  };

  return (
    <>
      <div className='header-seven'>
        <div className='header-seven-top'>
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <div className='header-seven-top-inner'>
                  <ul className='header-seven-top-left'>
                    <li>
                      <a href='tel:9945423080'>+91 99454 23080</a>
                    </li>
                    <li className='d-none d-sm-block'>
                      <Link to='/contact'>Bangalore, India</Link>
                    </li>
                  </ul>

                  <div className='header-seven-top__social'>
                    <a
                      className='social-item '
                      href='https://www.facebook.com/share/1EyHKLPMqQ/?mibextid=LQQJ4d'
                      target='_blank'
                      rel='noopener'
                    >
                      <i className='lastudioicon-b-facebook'></i>
                    </a>
                    <a
                      className='social-item'
                      href='https://www.instagram.com/saycheezecakes/profilecard/?igsh=MWRkMzJvM2M0OG5xYw=='
                      target='_blank'
                      rel='noopener'
                    >
                      <i className='lastudioicon-b-instagram'></i>
                    </a>
                    <a
                      className='social-item'
                      href='https://wa.me/919945423080'
                      target='_blank'
                      rel='noopener'
                    >
                      <i className='lastudioicon-b-whatsapp'></i>
                    </a>
                    <a
                      className='social-item'
                      href='mailto:saycheezecakes@gmail.com'
                      target='_blank'
                      rel='noopener'
                    >
                      <i className='lastudioicon-mail'></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`header-section header-transparent ${isSticky ? 'sticky' : ''}`}
          // style={{ position: 'sticky' }}
        >
          <div className='container position-relative'>
            <div className='row align-items-center'>
              <div className='col-lg-3 col-xl-3 col-7'>
                <div className='header-logo'>
                  <Link to='/'>
                    <img
                      className='white-logo landing_logo'
                      src={logoImg}
                      alt='Logo'
                      // style={{ transform: 'scale(1.3)' }}
                    />
                  </Link>
                </div>
              </div>
              <div className='col-lg-7 col-xl-6 d-none d-lg-block'>
                <div className='header-menu'>
                  <ul className='header-primary-menu d-flex justify-content-center'>
                    {renderLinks()}
                  </ul>
                </div>
              </div>
              <div className='col-lg-2 col-xl-3 col-5'>
                <div className='header-meta'>
                  <ul className='header-meta__action d-flex justify-content-end'>
                    <li onClick={handleSearchOpen}>
                      <button className='action search-open'>
                        <i className='lastudioicon-zoom-1'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className='action'
                        data-bs-toggle='offcanvas'
                        data-bs-target='#offcanvasCart'
                        onClick={() => navigate('/cart')}
                      >
                        <i className='lastudioicon-shopping-cart-2'></i>
                        <span className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-gold'>
                          {cartProducts?.length}
                        </span>
                      </button>
                    </li>
                    <li>
                      <a className='action' href='#' onClick={handleAddress}>
                        {/* {user && user?._id ? (
                          <LogoutIcon />
                        ) : ( */}
                        <i className='lastudioicon-single-01-2'></i>
                        {/* )} */}
                      </a>
                    </li>
                    <li className='d-lg-none'>
                      <button
                        className='action'
                        data-bs-toggle='offcanvas'
                        data-bs-target='#offcanvasMenu'
                        onClick={() => setShowSidebar(!showSidebar)}
                      >
                        <i className='lastudioicon-menu-8-1'></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* mobile canavas */}

      <Drawer open={showSidebar} onClose={toggleDrawer(false)}>
        <PerfectScrollbar>
          <div className={`offcanvas-menu bg-secondary h-100`}>
            <div className='offcanvas-header justify-content-end'>
              <button
                type='button'
                className='btn-close text-white'
                data-bs-dismiss='offcanvas'
                onClick={() => setShowSidebar(!showSidebar)}
              >
                <i className='lastudioicon-e-remove'></i>
              </button>
            </div>
            <div className='offcanvas-body'>
              <ul className='mobile-primary-menu'>{renderLinks()}</ul>
              <div style={{ position: 'absolute', bottom: '0' }}>
                <ul className='hotline-wrapper offcanvas-hotline'>
                  <li>
                    <div className='hotline'>
                      <i className='lastudioicon lastudioicon-support248'></i>
                      <div className='hotline-content'>
                        <span className='hotline-text'>Hotline</span>
                        <a className='hotline-link' href='tel:+919945423080'>
                          +91 99454 23080
                        </a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className='hotline'>
                      <i className='lastudioicon lastudioicon-pin-check'></i>
                      <div className='hotline-content'>
                        <span className='hotline-text'>Store Location</span>
                        <a className='hotline-link' href='#'>
                          Bangalore, Karnataka
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
                <div style={{ height: '10vh' }}></div>
              </div>
            </div>
          </div>
        </PerfectScrollbar>
      </Drawer>

      <div
        className={`search-popup position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-6 bg-black bg-opacity-75 ${
          searchModal ? 'open' : ''
        }`}
      >
        <div className='search-popup__form position-relative'>
          <form>
            <Autocomplete
              disablePortal
              options={searchOptions}
              onChange={handleSearchSelect}
              sx={{
                color: '#fff',
                '& .MuiInputBase-root': {
                  color: '#fff !important',
                },
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  sx={{ color: '#fff !important' }}
                  className='search-popup__field border-0 border-bottom bg-transparent text-white w-100 tra py-3'
                />
              )}
            />
            {/* <input
              className='search-popup__field border-0 border-bottom bg-transparent text-white w-100 tra py-3'
              type='text'
              placeholder='Search…'
              required
              value={userShopFilters?.search}
              onChange={handleProductSearch}
            /> */}
            <button className='search-popup__icon text-white border-0 bg-transparent position-absolute top-50 end-0 translate-middle-y'>
              <i className='lastudioicon-zoom-1'></i>
            </button>
          </form>
        </div>
        <button
          className='search-popup__close position-absolute top-0 end-0 m-8 p-3 lh-1 border-0 text-white fs-4'
          onClick={handleSearchModalClose}
        >
          <i className='lastudioicon-e-remove'></i>
        </button>
      </div>
    </>
  );
};

export default Header;
